import fetch from './fetch';

const getRecaptchaConfig = () => fetch('recaptcha-config')
  .then((response) => response.text())
  .catch(() => '');

export default getRecaptchaConfig;
